export enum PersonType {
    PF = 'PF',
    PJ = 'PJ'
}

export class PersonTypeHelper {
    static getLabel(type: PersonType | string | null | undefined): string {
        if (!type) return 'CNPJ';
        if (type === PersonType.PF || type === 'PF') return 'CPF';
        if (type === PersonType.PJ || type === 'PJ') return 'CNPJ';
        return 'CNPJ';
    }

    static getFullLabel(type: PersonType | string | null | undefined): string {
        if (!type) return 'Pessoa Jurídica';
        if (type === PersonType.PF || type === 'PF') return 'Pessoa Física';
        if (type === PersonType.PJ || type === 'PJ') return 'Pessoa Jurídica';
        return 'Pessoa Jurídica';
    }

    static isPF(type: PersonType | string | null | undefined): boolean {
        return type === PersonType.PF || type === 'PF';
    }

    static isPJ(type: PersonType | string | null | undefined): boolean {
        return type === PersonType.PJ || type === 'PJ';
    }
}
